<template>
  <div id="generate-document">
    <GlobalLoading v-if="isLoading" />
    <div class="document-container">
      <div
        ref="document"
        class="document-wrapper"
        style="padding: 0 !important"
      >
        <div
          style="width:100%;height:100%;display:flex;flex-direction:row;align-items:center; justify-content:center"
        >
          <kplh-template />
        </div>
      </div>
    </div>

    <button class="floating-button" @click="exportToPDF">Export to PDF</button>
    <button class="top-floating-button" @click="exportToPDF">
      Export to PDF
    </button>
  </div>
</template>

<script>
import VueJwtDecode from 'vue-jwt-decode'
import html2pdf from 'html2pdf.js'
import axios from 'axios'
import { api, api_lp } from '../../services/config'
export default {
  components: {
    GlobalLoading: () => import('@/components/V2/GlobalLoading.vue'),
    TableDetail: () =>
      import('@/components/molecules/tableDetailPenilaian.vue'),
    KplhTemplate: () => import('@/components/molecules/kplh/kplh-template.vue'),
  },
  data() {
    return {
      isVisible: false,
      isLoading: false,
    }
  },
  async created() {},
  methods: {
    async exportToPDF() {
      this.isVisible = true
      this.isLoading = true
      await html2pdf(this.$refs.document, {
        margin: [0.1, 0.1],
        filename: `K3L-Penilaian-${this.$route.params.vendor}.pdf`,
        image: { type: 'jpeg', quality: 1 },
        html2canvas: { scale: 4, dpi: 192, letterRendering: true },
        jsPDF: { unit: 'in', format: 'a4', orientation: 'portrait' },
        pagebreak: { mode: ['avoid-all', 'css', 'legacy'] },
      })
      this.isVisible = false
      this.isLoading = false
    },
  },
}
</script>
